export const DEFAULT_ROWS_COUNT_BEFORE_BANNER = 15;
